import { useQuery } from '@tanstack/react-query'

import { getIsWhiteLabel } from '~/helpers'

import {
  getPublisherConfigurationKey,
  getPublisherConfigurationService
} from '../services/configuration/publisher'

export const usePublisherConfig = ({
  publisherId
}: {
  publisherId?: PublisherId
} = {}) => {
  const queryKey = [getPublisherConfigurationKey, publisherId]

  const { isPending, isFetching, data, error } = useQuery({
    enabled: !!getIsWhiteLabel() || !!publisherId,
    queryKey,
    queryFn: async () => {
      const response = await getPublisherConfigurationService(publisherId)

      return response.data.configuration
    },
    placeholderData: previousData => previousData
  })

  return { isPending, isFetching, data, error }
}
